import { getDefaultLang } from "@cervval.js/common/src/i18n/languages";

const _fr = {
    checkboxLabel: "J'accepte les Conditions Générales de Vente d'Activmed",
    displayCGV: "Voir les Conditions Générales de Vente",
    cgv: "Conditions Générales de Vente d'Activmed",
    back: "Accepter les conditions",
    validationError: "Vous devez accepter les Conditions Générales de Vente pour continuer"
};

export type I18nCgvCheckbox = typeof _fr;

const _en: I18nCgvCheckbox = {
    checkboxLabel: "I accept the Terms of Service of Activmed",
    displayCGV: "See the Terms of Service",
    cgv: "Terms of Service of Activmed",
    back: "Accept terms",
    validationError: "You must accept terms in order to continue"
};

/**
 * Return value in required language
 * @param lang Chosen lang
 * @returns 
 */
export function i18nCgvCheckbox(lang?: string): I18nCgvCheckbox {
    lang = lang ?? getDefaultLang();
    switch (lang) {
        case "en":
            return _en;
        case "fr":
        default:
            return _fr;
    }
}